/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
export const recipientStyles = css`
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        column-gap: 1rem;
    `
